import { isFactory } from './matcherFactory';

const isFullHedging = isFactory('full_hedging');
const isLimitedHedging = isFactory('limited_hedging');
const isViewAndShip = isFactory('view_and_ship');
const isShipOnly = isFactory('ship_only');
const isLimited = isFactory('limited');

export { isFullHedging, isLimitedHedging, isViewAndShip, isShipOnly, isLimited };
